exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main-content[data-v-66a8aa1c] {\n  padding-bottom: 5rem;\n}\n.bottom-button[data-v-66a8aa1c] {\n  z-index: 10;\n  height: auto;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.menu-text[data-v-66a8aa1c] {\n  color: #00ACC1 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-66a8aa1c","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobPost/JobPostDetail.vue
// module id = 2332
// module chunks = 0